export default "__VITE_PUBLIC_ASSET__46c82520__"